import { useFormContext } from 'react-hook-form'

import { Label } from 'ui/temp/Label'

import { FFProps } from './FF2.types'

import { s } from './styles'

const getValue = (obj, path) => path.split('.').reduce((o, k) => o?.[k], obj)

export const FF2 = (props: FFProps) => {
  const { label, errorPosition = 'bottom', input, required, field } = props
  const {
    formState: { errors }
  } = useFormContext()
  const error = field.name ? getValue(errors, field.name) : undefined

  return (
    <s.Container data-qa={`form_${field.name}`}>
      {!!label && <Label $error={!!error}>{label}</Label>}
      <div style={{ display: errorPosition === 'right' ? 'flex' : 'block', alignItems: 'baseline' }}>
        {input && input({ required, error, ...field })}
        {!!error && (
          <s.Error
            data-field-with-error={field.name}
            data-fieldlabel={label}
            data-fielderror={error.message}
            $error
            $position={errorPosition}
          >
            {error.message}
          </s.Error>
        )}
      </div>
    </s.Container>
  )
}
